import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {RoomInfo} from "@/core/api/room.info.api";
import {roomMediaService} from "@/core/service/room.media.service";
import _ from 'lodash';

class RoomMediaApi extends BaseApi {
    #roomMediaService;

    constructor() {
        super();
        Room.Media = this;

        Room.ready(async e => {
            if(!RoomInfo.useModule('mediaShare')){
                return;
            }

            this._eventListen(this.#Events);

            this.#roomMediaService = roomMediaService;

            let {data} = await this.#roomMediaService.getRoomMediaInfoList();
            if(!data) {
                console.error('get roomMedia file :', data);
                return;
            }

            let roomGroups = data.reduce((map, roomMedia) => {
                map[roomMedia.roomGroupId] = roomMedia;
                Room.Group.addData(roomMedia.roomGroupId, {roomMedia});
                return map;
            }, {});

            let roomMedia = roomGroups['default'];
            if(roomMedia) {
                roomMedia.roomGroups = roomGroups;
                Room.addRoomData({roomMedia});
            }

        })
    }


    async addRoomMedia(roomMedia) {

    }

    async addRoomMediaFile(roomMediaFile) {

    }

    async getRoomMedia(roomGroupId='default') {
        let roomGroup = Room.Group.getRoomGroup(roomGroupId);
        if(!roomGroup) {
            return null;
        }
        return roomGroup.roomMedia;
    }

    async getRoomMediaFiles({roomGroupId='default'}) {
        let roomGroupData = Room.Group.getRoomGroup(roomGroupId);
        let list = roomGroupData.roomMedia.roomMediaFiles;
        return list;
    }

    async getRoomMediaFile({mediaId, roomGroupId='default'}) {
        let roomGroupData = Room.Group.getRoomGroup(roomGroupId);
        let list = roomGroupData.roomMedia.roomMediaFiles;
        let roomMediaFile = list.find(file => file.mediaId === mediaId);
        return roomMediaFile;
    }

    async uploadRoomMediaFile({roomGroupId, filename, file, onUploadProgress}) {
        return this.#roomMediaService.uploadRoomMediaFile({roomGroupId, filename, file, onUploadProgress})
    }

    async removeRoomMediaFile({roomGroupId, mediaId}) {
        await this.#roomMediaService.removeRoomMediaFile({roomGroupId, mediaId});
    }

    async changeRoomMedia({roomGroupId, mediaId}) {
        return await this.#roomMediaService.changeRoomMedia({roomGroupId, mediaId});
    }

    async playRoomMedia({roomGroupId, mediaId, seekTime}) {
        await this.#roomMediaService.playRoomMedia({roomGroupId, mediaId, seekTime})
    }

    async pauseRoomMedia({roomGroupId, seekTime, autoPause}) {
        await this.#roomMediaService.pauseRoomMedia({roomGroupId, seekTime, autoPause})
    }

    async createRoomMediaDownloadUrl({mediaId}) {
        return await this.#roomMediaService.createRoomMediaDownloadUrl({mediaId});
    }

    async changeRoomMediaPlayType({roomGroupId, playType}) {
        await this.#roomMediaService.changeRoomMediaPlayType({roomGroupId, playType});
    }
    async generateUploadPresignedUrl() {
        return (await this.#roomMediaService.generateUploadPresignedUrl()).data
    }
    async completePresignedUrl(data) {
        await this.#roomMediaService.completePresignedUrl(data)
    }
    #Events = {
        room_media_add: async function(e){
            let {roomMediaFile} = e.data;
            let roomMedia = await this.getRoomMedia(roomMediaFile.roomGroupId);
            if(!roomMedia){
                console.warn('roomMedia is null :', roomMediaFile);
            }

            let prev = await this.getRoomMediaFile(roomMediaFile);
            if(prev){
                _.merge(prev, roomMediaFile);
                roomMediaFile = prev;
            }else{
                roomMedia.roomMediaFiles.push(roomMediaFile);
            }

            Room.emit(e.type, {userId: e.userId, roomMediaFile: _.cloneDeep(roomMediaFile)});
        },
        room_media_remove: async function(e) {
            let {roomGroupId, mediaId} = e.data;
            let roomMedia = await this.getRoomMedia(roomGroupId);
            if(!roomMedia) {
                console.warn('roomMedia is null :', roomGroupId);
            }

            let idx = roomMedia.roomMediaFiles.findIndex(roomMediaFile => roomMediaFile.mediaId == mediaId);
            if(idx < 0){
                return;
            }
            roomMedia.roomMediaFiles.splice(idx, 1);

            Room.emit(e.type, {userId: e.userId, roomGroupId, mediaId});
        },
        room_media_change: async function(e) {
            let {roomMedia} = e.data;
            let rm = await this.getRoomMedia(roomMedia.roomGroupId);
            if(!rm){
                console.warn('roomMedia is null :', e.data);
                return;
            }

            rm.mediaId = roomMedia.mediaId;
            rm.playState = roomMedia.playState;
            rm.currentPlayTime = roomMedia.currentPlayTime;
            rm.lastPlayDate = roomMedia.lastPlayDate;

            Room.emit(e.type, {roomMedia: roomMedia})

        },
        room_media_player_play: async function(e) {
            let {roomGroupId, mediaId, seekTime} = e.data;
            let roomMedia = await this.getRoomMedia(roomGroupId);
            if(!roomMedia){
                console.warn('roomMedia is null :', e.data);
                return;
            }
            if(roomMedia.mediaId !== mediaId) {
                console.warn('roomMedia mediaId is not the same :', mediaId, roomMedia);
                return;
            }
            roomMedia.seekTime = seekTime;

            Room.emit(e.type, {roomGroupId, mediaId, seekTime})
        },
        room_media_player_pause: async function(e) {
            let {roomGroupId, seekTime} = e.data;
            let roomMedia = await this.getRoomMedia(roomGroupId);
            if(!roomMedia){
                console.warn('roomMedia is null :', e.data)
                return;
            }

            roomMedia.playState = 'paused';
            roomMedia.seekTime = seekTime;

            Room.emit(e.type, {roomGroupId, seekTime})
        }
    };
}

export const RoomMedia = new RoomMediaApi();